import { Box, CircularProgress, SxProps, Theme, Typography, alpha } from "@mui/material";
import { ReactNode } from "react";

type PageHeaderProps = {
  title: ReactNode;
  /** Trilha de navegação (breadcrumb) exibida acima do título. */
  breadcrumb?: ReactNode;
  /** Texto exibido no lugar do título quando há itens selecionados (ex: "3 selecionados"). */
  selectedLabel?: ReactNode;
  isSelectionActive?: boolean;
  loading?: boolean;
  /** Botões/ações renderizados à direita do título. */
  children?: ReactNode;
  /** Estilos extras para a linha de título (ex: padding ao usar dentro de um Paper de listagem). */
  sx?: SxProps<Theme>;
};

/** Título padrão de página (h6), com suporte opcional a breadcrumb e estado de seleção de listagens. */
export function PageHeader({
  title,
  breadcrumb,
  selectedLabel,
  isSelectionActive = false,
  loading = false,
  children,
  sx,
}: PageHeaderProps) {
  return (
    <Box sx={{ mb: 2 }}>
      {breadcrumb ? <Box sx={{ mb: 1 }}>{breadcrumb}</Box> : null}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          ...(isSelectionActive && {
            bgcolor: (theme) =>
              alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
          }),
          ...sx,
        }}
      >
        <Typography variant="h6" component="h1">
          {isSelectionActive && selectedLabel ? selectedLabel : title}
          {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Typography>
        {children}
      </Box>
    </Box>
  );
}

export default PageHeader;
